export function cleanBackendMessage(message?: string): string {
  if (!message) {
    return "";
  }
  if (message.includes("|")) {
    return message.split("|")[0].trim();
  }
  return message.trim();
}
